export const getTestId = (testIdPrefix: string | undefined, suffix: string) =>
  testIdPrefix ? `${testIdPrefix}-${suffix}` : suffix;
